import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { ConfigProvider, Layout, message, Spin, theme } from 'antd';
import Home from './pages/home';
import TrialCustomers from './pages/trialCustomers';
import PaidCustomers from './pages/paidCustomers';
import SideBar from './include/SideBar';
import TopBar from './include/TopBar';
import Transactions from './pages/transactions';
import Templates from './pages/templates';
import Help from './pages/help';
import LoginForm from './pages/login';
import { LoadingOutlined } from '@ant-design/icons';

const { Content } = Layout;

function App() {
  const location = useLocation();
  const adminLoginToken = localStorage.getItem('adminLoginToken');
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const keyFromUrl = queryParams.get('key') || location.pathname.split('/')[1];
    if (keyFromUrl) {
      setSelectedKey(keyFromUrl);
    } else {
      setSelectedKey('home');
    }
  }, [location]);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleMenuClick = ({ key }) => {
    navigate(key === 'home' ? '/' : `/${key}`);
  };

  const fetchUserData = useCallback(async () => {
    const url = `${window.API_BASE_URL}/users/admin`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${adminLoginToken}`,
        },
      });
      const data = await response.json();
      console.log(data);
      if (response.ok) {
        setUserData(data.user);
        setLoading(false);
      } else {
        if (data.message === 'Invalid token') {
          localStorage.removeItem('adminLoginToken');
          localStorage.removeItem('adminDeviceId');
        }
        console.error('Error fetching user data:', data.message);
      }
    } catch (error) {
      console.error('Error during fetching user data:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminLoginToken]);

  useEffect(() => {
    if (adminLoginToken) {
      fetchUserData();
    } else {
      setLoading(false);
    }
  }, [fetchUserData, adminLoginToken]);

  return (
    <>
      {contextHolder}
      {loading ? (
        <div className='main-loading-div'>
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
          />
        </div>
      ) : (
        !adminLoginToken ? (
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        ) : (
          <Layout>
            <SideBar collapsed={collapsed} selectedKey={selectedKey} handleMenuClick={handleMenuClick} />
            <Layout style={{ marginInlineStart: collapsed ? 80 : 200, transition: 'margin-inline-start 0.3s ease' }}>
              <TopBar colorBgContainer={colorBgContainer} collapsed={collapsed} setCollapsed={setCollapsed} selectedKey={selectedKey} messageApi={messageApi} />
              <Content
                style={{
                  margin: '24px 18px',
                  padding: 12,
                  height: 'calc( 100vh - 112px )',
                  overflow: 'hidden',
                  overflowY: 'auto',
                  background: colorBgContainer,
                  borderRadius: borderRadiusLG,
                  scrollbarWidth: 'thin'
                }}
              >

                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/trial-customers" element={<TrialCustomers />} />
                  <Route path="/paid-customers" element={<PaidCustomers />} />
                  <Route path="/templates" element={<Templates />} />
                  <Route path='/help' element={<Help />} />
                  <Route path="/recent-transactions" element={<Transactions />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </Content>
            </Layout>
          </Layout>
        )
      )}
    </>
  );
}

function Connectby() {
  return (
    <ConfigProvider direction="ltr" theme={{ token: { colorPrimary: '#3A1A55' } }}>
      <Router>
        <App />
      </Router>
    </ConfigProvider>
  );
}

export default Connectby;
